export const name = "SIN";
export const summary = `Computes the sine of \`X\`.`;
export const reference = `
## SIN

Computes the sine of \`X\`.

\`\`\`
SIN(X)
\`\`\`

### Description

Computes the sine of X where X is specified in radians. Never fails.

| X | SIN(X) |
| --- | --- |
| \`+inf\` | \`NaN\` |
| \`-inf\` | \`NaN\` |
| \`NaN\` | \`NaN\` |


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
